export const getExpiresTime = (num) =>{
  let expiresTime=new Date();
  expiresTime.setTime(new Date().getTime()+24*3600*1000*num)
  expiresTime=expiresTime.toGMTString();
  return expiresTime
}
export const  base64ToHex = (data) =>{
  let base64 = Base64.encode(Base64.encode(data));
  // 将Base64编码转换为二进制字符串
  var binaryString = atob(base64);
  const uint8Array = new Uint8Array(binaryString.length);
  for (var i = 0; i < binaryString.length; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }
  // 初始化16进制字符串
  var hexString = "";
  // 遍历二进制字符串，转换每个字节为16进制
  for (var i = 0; i < uint8Array.length; i++) {
    const hex = uint8Array[i].toString(16).padStart(2, "0");
    // 追加到16进制字符串
    hexString += hex;
  }
  hexString = hexString.toUpperCase();
  return hexString;
}